"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Error;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Error(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, props.code, " - ", props.message, " ");
}